module.exports = __webpack_public_path__ + "static/img/85048H_1_2_R_20200908_fit.37ccc77.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/85048H_1_2_R_20200908_fit.png
// module id = p110
// module chunks = 0